export const SET_MSEID = 'SET_MSEID'
export const SET_USERNAME = 'SET_USERNAME'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js